var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-header"},[_c('div',{class:{'contact-header-inner': _vm.mounted}})])}
var staticRenderFns = []

export { render, staticRenderFns }